const CONTENT_BY_FORMAT = {
  profile: 'profile_link',
  story: 'story_01',
  post: 'post_01',
  reel: 'reel_01',
  ad: 'ad_01',
  banner_ad: 'banner_01',
  email: 'email_01',
  broadcast: 'broadcast_01',
  partner_post: 'partner_post_01',
  other: 'other_01',
}

const buildUtmContent = ({ format }) => (format ? CONTENT_BY_FORMAT[format] ?? '' : '')

export default buildUtmContent
